import type { CreditCardWithCurrencies } from '@contracts/payment/CreditCard';
import Typography from '@mui/material/Typography';
import { BaseModal } from '@src/common/components/BaseModal';
import { CloseConfirmModalFooter } from '@src/common/components/modal/CloseConfirmModalFooter';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import { Trash01 } from '@untitled-ui/icons-react';
import { Trans, useTranslation } from 'react-i18next';

export const DeleteCreditCardModal = ({
  creditCard,
  open,
  onClose,
  onConfirm,
}: {
  creditCard: CreditCardWithCurrencies | null;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useTranslation();

  if (!creditCard) return null;

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title={t('savedCreditCards.deleteModal.title')}
      titleIcon={<Trash01 />}
    >
      <Stack gap={theme.spacing['3']}>
        <Typography>
          <Trans
            i18nKey="savedCreditCards.deleteModal.message"
            values={{
              cardName: creditCard.cardName,
              nameOnCard: creditCard.nameOnCard,
            }}
            components={[
              <Typography
                key="bold-text"
                component="span"
                sx={{ fontWeight: 'bold' }}
              />,
            ]}
          />
        </Typography>

        <CloseConfirmModalFooter
          onClose={onClose}
          confirm={onConfirm}
          confirmLabel={t('savedCreditCards.deleteModal.confirm')}
          closeLabel={t('savedCreditCards.deleteModal.cancel')}
        />
      </Stack>
    </BaseModal>
  );
};
